import React from 'react';
import { ToolbarItemProps } from '../../store/slice';
import { MoreToolsGroup, MoreToolsItem } from './styles';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const MoreToolsView: React.VFC<ToolbarItemProps> = (item) => {
  return (
    <>
      {item.sidebarGroups.map((group) => (
        <MoreToolsGroup key={group.title}>
          <h5>{group.title}</h5>
          {group.links.map((sideNavLinkProp) => (
            <MoreToolsItem
              href={sideNavLinkProp.link.url}
              key={sideNavLinkProp.id}
              {...getTaktAttributes(sideNavLinkProp.id, chromeComponents.NAV, {
                url: sideNavLinkProp.link.url,
              })}
            >
              {sideNavLinkProp.link.label}
            </MoreToolsItem>
          ))}
        </MoreToolsGroup>
      ))}
    </>
  );
};

export default MoreToolsView;
